import { ConfigurationOntology } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { uniqueId } from 'lodash'
import { ConfigurationTextTemplateResponse } from '@/modules/configurationModule/detail/templates/text-templates/services/text-templates.dto'

export enum TextTemplateTabIndex {
    FORM_DATA = 0,
    ONTOLOGIES = 1,
}

export interface ConfigurationOntologyTextTemplate extends ConfigurationOntology {
    templateId: number
}

export interface TextTemplatesModalState {
    activeTabIndex: number
    selectedRow: ConfigurationTextTemplateResponse
    modalUID: string
    ontologies: ConfigurationOntologyTextTemplate[]
}
export const initialTextTemplatesModalState =
    (): TextTemplatesModalState => ({
        activeTabIndex: TextTemplateTabIndex.FORM_DATA,
        selectedRow: {
            active: true,
            text: '',
            textEditionAllowed: false,
            title: '',
            variablesAndOptions: {}
        },
        modalUID: uniqueId(),
        ontologies: []
    })
